import React from 'react';
import { connect } from 'react-redux';
import Financial from './financial';
import Overview from './overview/Overview';
import Performance from './performance';
import Technical from './technical';
import {
  cancelFetchListTopForeignTradeTable,
  fetchListTopForeignTradeTable,
  REDUCER_NAME,
} from './reducer';
import Chart from './chart/Chart';
import Footer from '../../../common/table/Footer';
import AutoReloadOnFocusBlurComponent from '../../../../core/loading/AutoReloadOnFocusBlur';

class AllExchanges extends AutoReloadOnFocusBlurComponent {
  reload() {
    const { dispatch, filter, option } = this.props;
    dispatch(fetchListTopForeignTradeTable(filter, option));
  }

  componentDidMount() {
    super.componentDidMount();
    const { dispatch, filter, option } = this.props;
    dispatch(fetchListTopForeignTradeTable(filter, option));
  }

  componentDidUpdate(prevProps) {
    const { dispatch, filter, option } = this.props;
    if (
      prevProps.i18n.locale !== this.props.i18n.locale ||
      option !== prevProps.option
    ) {
      dispatch(fetchListTopForeignTradeTable(filter, option));
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    const { dispatch } = this.props;
    dispatch(cancelFetchListTopForeignTradeTable());
  }

  render() {
    const { typeTab } = this.props;
    return (
      <div className="tab-pane active top-mover-content d-flex flex-fill flex-column">
        {typeTab !== 5 && (
          <div className="d-flex flex-fill flex-column pl-20 pr-20">
            {typeTab === 1 && <Overview />}
            {typeTab === 2 && <Performance />}
            {typeTab === 3 && <Financial />}
            {typeTab === 4 && <Technical />}

            <Footer />
          </div>
        )}

        {typeTab === 5 && <Chart />}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  i18n: state.i18n,
  option: state[REDUCER_NAME].option,
});

export default connect(mapStateToProps)(AllExchanges);
